export enum ScreeningStatus {
  APPROVED = "approved",
  PENDING_APPROVAL = "pending_approval",
  REJECTED = "rejected",
  INACTIVE = "inactive",
  SUSPENDED = "suspended",
  DORMANT = "dormant",
  DOCNEEDRESUBMISSION = "document_need_resubmission",
}
